import { useRecoilValue } from 'recoil';
import { CONTROL_TOWER_PAGE, GPT_DETAIL_PAGE, LIVE_STATUS_PAGE, NOTIFICATION_PAGE } from '../../constants/app';
import { isAllWorkspacesSelect, pageState, sidenavIsVisibleState } from '../../storage/app';
import { Navbar } from '../dashboard/Navbar';
import { Sidenav } from '../dashboard/Sidenav';
import AllGroupsProvider from '../providers/AllGroupsProvider';
import AssetsProvider from '../providers/AssetsProvider';
import ClientCameraProvider from '../providers/ClientCameraProvider';
import ClientProvider from '../providers/ClientProvider';
import { DeliveryFencesGeoJsonProvider } from '../providers/DeliveryFencesGeojsonProvider';
import { FencesGeoJsonProvider } from '../providers/FencesGeojsonProvider';
import GptAlarmTypesProvider from '../providers/GptAlarmTypesProvider';
import NotificationProvider from '../providers/NotificationsProvider';
import { PermissionsProvider } from '../providers/PermissionsProvider';
import PusherProvider from '../providers/PusherProvider';
import PusherSafeGptProvider from '../providers/PusherSafeGptProvider';
import { SpotsProvider } from '../providers/SpotsProvider';
import { ZoneFencesProvider } from '../providers/ZoneFencesProvider';
import DashboardWrapper from '../shared/DashboardWrapper';

export function Dashboard() {
  const page = useRecoilValue(pageState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const sidenavIsVisible = useRecoilValue(sidenavIsVisibleState);

  const withMarginLeft = (() => {
    if (sidenavIsVisible) return true;
    return false;
  })();

  return (
    <DashboardWrapper
      navbar={<Navbar />}
      sidenav={sidenavIsVisible && <Sidenav />}
      withMarginLeft={withMarginLeft}
      providers={
        <>
          <PermissionsProvider />
          <SpotsProvider />
          <ZoneFencesProvider />
          {/* TODO: review if client provider is needed for almost all pages */}
          {page !== NOTIFICATION_PAGE.id && page !== LIVE_STATUS_PAGE.id && <ClientProvider />}
          {page !== NOTIFICATION_PAGE.id && page !== LIVE_STATUS_PAGE.id && page !== GPT_DETAIL_PAGE.id && (
            <ClientCameraProvider />
          )}
          {!isAllWorkspacesSelected && <AllGroupsProvider />}
          {page !== NOTIFICATION_PAGE.id && page !== LIVE_STATUS_PAGE.id && <PusherProvider />}
          {page !== NOTIFICATION_PAGE.id && page !== LIVE_STATUS_PAGE.id && <AssetsProvider />}
          {page === CONTROL_TOWER_PAGE.id && <PusherSafeGptProvider />}
          {!isAllWorkspacesSelected && page !== NOTIFICATION_PAGE.id && <FencesGeoJsonProvider />}
          {!isAllWorkspacesSelected && page !== NOTIFICATION_PAGE.id && <DeliveryFencesGeoJsonProvider />}
          {!isAllWorkspacesSelected && page !== NOTIFICATION_PAGE.id && page !== LIVE_STATUS_PAGE.id && (
            <NotificationProvider />
          )}
          <GptAlarmTypesProvider />
        </>
      }
    />
  );
}
